import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Row, Col } from "reactstrap";
interface IReactPrintProps {
  body: any;
}
interface IReactPrintState {
  body: any;
}
class ComponentToPrint extends React.PureComponent<IReactPrintProps, IReactPrintState> {
  constructor(props: IReactPrintProps) {
    super(props);
    this.state = {
      body: props.body
    };
  }
  render() {
    return (
      <React.Fragment>
        {this.state.body}
      </React.Fragment>
    );
  }
}
/* tslint:disable */
const REACT_PRINT_COMPONENT = ({ body}: any) => {
  const componentRef = useRef();
  return (
    <React.Fragment>
      <Row>
        <Col xs={12} className="text-right mt-5">
          <ReactToPrint trigger={() => <button>Imprimir</button>} content={() => componentRef.current} removeAfterPrint={true} />
        </Col>
        <Col xs={12}>
          <ComponentToPrint ref={componentRef} body={body} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default REACT_PRINT_COMPONENT;
